<template>
    <PageHeader :name="username" :is-admin="isAdmin">
        <template #home>
            <div>
                <DeviceTable :is-admin="isAdmin" :groups="groups"/>
            </div>
        </template>
        <template #usertools v-if="isAdmin">
            <div>
                <UserTools :users="users" :devices="devices" :groups="groups" @data-updated="updateData" />
            </div>
        </template>
        <template #grouptools v-if="isAdmin">
            <div>
                <GroupTools :users="users" :devices="devices" :groups="groups" @data-updated="updateData" />
            </div>
        </template>
        <template #devicetools v-if="isAdmin">
            <div>
                <DeviceTools :devices="devices" :groups="groups" @data-updated="updateData" />
            </div>
        </template>
        <template #userinfo>
            <div>
                <UserInfo v-if="user" :is-admin="isAdmin" :user="user" :groups="groups" />
            </div>
        </template>
    </PageHeader>
</template>

<script>
import { mapState } from 'vuex';
import { defineAsyncComponent } from 'vue';
import PageHeader from './PageHeader.vue';
import DeviceTable from './DeviceTable.vue';
// Lazy-load admin-only components
const UserTools = defineAsyncComponent(() => 
  import(/* webpackChunkName: "admin-tools" */ './UserTools.vue')
);
const DeviceTools = defineAsyncComponent(() => 
  import(/* webpackChunkName: "admin-tools" */ './DeviceTools.vue')
);
const GroupTools = defineAsyncComponent(() => 
  import(/* webpackChunkName: "admin-tools" */ './GroupTools.vue')
);
import UserInfo from './UserInfo.vue';
import { fetchData } from '@/helpers';

export default {
    name: 'HomePage',
    components: {
        PageHeader,
        DeviceTable,
        UserTools,
        DeviceTools,
        GroupTools,
        UserInfo
    },
    data() {
        return {
            users: [],
            groups: [],
            devices: [],
            isAdmin: false,
            // Gate updates until initial page settles
            initialized: false
        };
    },
    computed: {
        ...mapState({
            username: state => state.username
        }),
        user() {
            return this.users.find(user => user.user_username === this.username);
        }
    },
    methods: {
        fetchData,
        async updateData() {
            // Skip updates during initial load cooldown
            if (!this.initialized) {
                return;
            }
            if (this.isAdmin) {
                this.users = await this.fetchData('users');
                this.groups = await this.fetchData('groups');
                this.devices = await this.fetchData('devices');
            } else {
                this.users = await this.fetchData('users', { user_username: this.username });
                this.groups = await this.fetchData('groups');
            }
        }
    },
    async created() {
        this.isAdmin = await this.fetchData('admin');
        if (this.isAdmin) {
            this.users = await this.fetchData('users');
            this.groups = await this.fetchData('groups');
            this.devices = await this.fetchData('devices');
        } else {
            this.users = await this.fetchData('users', { user_username: this.username });
            this.groups = await this.fetchData('groups');
        }
        // Allow updates after a short stabilization period
        setTimeout(() => {
            this.initialized = true;
        }, 5000);
    }
}
</script>

<style>
/* Add any custom styles here */
</style>